import { useState, useEffect, useCallback } from 'react'
export interface TodoItem {
  id: string
  text: string
  completed: boolean
  priority: 'high' | 'medium' | 'low'
  color: string
  category: string
  link?: string
  createdAt: string
  dueDate?: string
}
const STORAGE_KEY = 'vsm_todos'
const DEFAULT_TODOS: TodoItem[] = [
  {
    id: 't1',
    text: 'Revisar PRs pendientes de autenticación',
    completed: false,
    priority: 'high',
    color: '#ef4444',
    // red
    category: 'Development',
    link: 'https://github.com/org/repo/pulls',
    createdAt: new Date().toISOString(),
  },
  {
    id: 't2',
    text: 'Actualizar documentación de API',
    completed: false,
    priority: 'medium',
    color: '#f59e0b',
    // amber
    category: 'Docs',
    createdAt: new Date().toISOString(),
  },
  {
    id: 't3',
    text: 'Preparar demo para el sprint review',
    completed: false,
    priority: 'high',
    color: '#3b82f6',
    // blue
    category: 'Management',
    createdAt: new Date().toISOString(),
  },
  {
    id: 't4',
    text: 'Responder feedback de QA en VSM-102',
    completed: true,
    priority: 'medium',
    color: '#10b981',
    // emerald
    category: 'QA',
    link: 'https://jira.com/browse/VSM-102',
    createdAt: new Date(Date.now() - 86400000).toISOString(),
  },
]
export function useTodos() {
  const [todos, setTodos] = useState<TodoItem[]>(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (stored) return JSON.parse(stored)
    } catch (e) {
      console.error('Error loading todos', e)
    }
    return DEFAULT_TODOS
  })
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(todos))
  }, [todos])
  const addTodo = useCallback((todo: Omit<TodoItem, 'id' | 'createdAt'>) => {
    const newTodo: TodoItem = {
      ...todo,
      id: Math.random().toString(36).substring(2, 9),
      createdAt: new Date().toISOString(),
    }
    setTodos((prev) => [newTodo, ...prev])
  }, [])
  const toggleTodo = useCallback((id: string) => {
    setTodos((prev) =>
      prev.map((t) =>
        t.id === id
          ? {
              ...t,
              completed: !t.completed,
            }
          : t,
      ),
    )
  }, [])
  const removeTodo = useCallback((id: string) => {
    setTodos((prev) => prev.filter((t) => t.id !== id))
  }, [])
  const updateTodo = useCallback((id: string, updates: Partial<TodoItem>) => {
    setTodos((prev) =>
      prev.map((t) =>
        t.id === id
          ? {
              ...t,
              ...updates,
            }
          : t,
      ),
    )
  }, [])
  const reorderTodos = useCallback((startIndex: number, endIndex: number) => {
    setTodos((prev) => {
      const result = Array.from(prev)
      const [removed] = result.splice(startIndex, 1)
      result.splice(endIndex, 0, removed)
      return result
    })
  }, [])
  return {
    todos,
    addTodo,
    toggleTodo,
    removeTodo,
    updateTodo,
    reorderTodos,
  }
}
